import type { Dayjs } from 'dayjs'

export interface DisabledTimeOptions {
  disabledHours?: () => number[]
  disabledMinutes?: (hour: number) => number[]
  disabledSeconds?: (hour: number, minute: number) => number[]
}
export interface TimePanelOptions extends DisabledTimeOptions {
  format?: string
  hourStep?: number
  minuteStep?: number
  secondStep?: number
  hideDisabledOptions?: boolean
}
export interface TimeConfig extends TimePanelOptions { defaultValue?: Dayjs }
export function isTimeDisabled(value: Dayjs, options: DisabledTimeOptions): boolean {
  return Boolean(options.disabledHours?.().includes(value.hour()) || options.disabledMinutes?.(value.hour()).includes(value.minute()) || options.disabledSeconds?.(value.hour(), value.minute()).includes(value.second()))
}
export function timeOptions(limit: number, step = 1): number[] {
  if (!Number.isInteger(step) || step <= 0) throw new RangeError('时间步长必须是正整数')
  return Array.from({ length: Math.ceil(limit / step) }, (_, index) => index * step)
}
